/**
 * Mobile nav toggle open and menu items open
 */
export const mobileNav = () => {
    const theButton = document.querySelector('#mobile-nav-butt');
    const theTrigger = document.querySelectorAll('.mobile-nav');

    theButton.onclick = function () {
        for (const x of theTrigger) {
            x.classList.toggle('mob-nav-active');
        }
    };
    /* icon toggle */

    document
        .getElementById('mobile-nav-butt')
        .addEventListener('click', function () {
            document.getElementById('mobile-nav-butt').classList.toggle('icon-toggle');
        });
};